import { connect } from "react-redux";
import UserManagementPage from "./UserManagementPage"
import { fetchAllUsers } from "../../../../redux/actions/user_actions"

const mapStateToProps = (state) => {
    return ({
        users: state.users,
        currentUserRole: state.session.user.role,
    });
}

const mapDispatchToProps = (dispatch) => {
    return ({
        fetchAllUsers: (cancelToken) => dispatch(fetchAllUsers(cancelToken)),
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(UserManagementPage);
